import PropTypes from 'prop-types';
import {useEffect, useState} from 'react';
import globe from '../../../../svg/icons/globe.svg';
import person from '../../../../svg/icons/person.svg';
import RefreshIcon from '../../../../svg/icons/RefreshIcon';
import Button from '../../../UI/Button/Button';
import Spinner from '../../../v2/components/ui/Spinner';
import error from '../../../v2/components/ui/svg/error.svg';
import Translation from '../../../v2/lang/Translation';

import bigQueryMetricRecorder from '../../../v2/tracking/bigQueryMetricRecorder';
import Track from '../../../v2/utils/tracking';

function ConnectionLost(props) {
  const [waiting, setWaiting] = useState(false);
  const subtype = props.subtype ? props.subtype : 'DeliveryOptionsNetworkError';
  
  useEffect(() => {
    try {
      bigQueryMetricRecorder(subtype, [], [], 'impression');
    } catch (err) {
      Track.track(err);
    }
  }, []);
  
  const handleClick = () => {
    if (!waiting) {
      setWaiting(true);
      setTimeout(() => {
        if (!props.onClick) {
          window.location.reload();
        } else {
          props.onClick();
        }
        setWaiting(false);
      }, 500);
    }
  };
  
  return (
    <div className="ConnectionLost" data-test={`ConnectionLost--${subtype}`}>
      <p className="ConnectionLost__message">
        <Translation>connection.lost</Translation>
      </p>
      {props.subMessageTranslationKey && (
        <p>
          <Translation>{props.subMessageTranslationKey}</Translation>
        </p>
      )}
      <div className="ConnectionLost__diagram">
        <img className="ConnectionLost__person" src={person} alt="" />
        {waiting
          ? (
            <span className="ConnectionLost__exclamation">
              <Spinner size="extra-small" />
            </span>
          ) : (
            <img className="ConnectionLost__exclamation" src={error} alt="" />
          )}
        
        <img className="ConnectionLost__globe" src={globe} alt="" />
      </div>
      <Button
        id="ConnectionLost__tryAgainButton"
        className="ConnectionLost__button"
        primary
        fullWidth
        onClick={handleClick}
      >
        <RefreshIcon className="ConnectionLost__refreshIcon" />
        <Translation>try.again</Translation>
      </Button>
    </div>
  );
}

ConnectionLost.propTypes = {
  subtype: PropTypes.string,
  subMessageTranslationKey: PropTypes.string,
  onClick: PropTypes.func,
};

export default ConnectionLost;
